import React, { useState } from "react";
import Slider from "react-slick";
import { navigate } from "gatsby";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import CardAuthor from "../../atoms/card-author/cardAuthor";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";

import "./featuredAuthors.scss";

const FeaturedAuthors = (props: ReferenciaContenido) => {
  // Funciones para desktop
  const [sliderIndex, setSliderIndex] = useState(0);
  const [slider, setSlider] = useState<any>();
  const settings = {
    centermode: true,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow:
      props.referenciaPlantillaContenido.length > 4
        ? 4
        : props.referenciaPlantillaContenido.length,
    slidesToScroll:
      props.referenciaPlantillaContenido.length > 4
        ? 4
        : props.referenciaPlantillaContenido.length,
    beforeChange: (_: number, next: number) => setSliderIndex(next),
    responsive: [
      {
        breakpoint: 960,
        settings: {
          centerMode: false,
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };
  const goToNext = () => {
    slider.slickGoTo(sliderIndex + 4);
  };

  const goToBack = () => {
    slider.slickGoTo(sliderIndex - 4);
  };

  const isActiveNext = (_true: any, _false: any) => {
    return sliderIndex < props.referenciaPlantillaContenido.length - 4
      ? _true
      : _false;
  };

  const isActiveBack = (_true: any, _false: any) =>
    sliderIndex > 0 ? _true : _false;

  const handleLimitData = () => {
    const auxItem: any = [];
    for (let index = 0; index < 10; index++) {
      auxItem.push(props.referenciaPlantillaContenido[index]);
    }
    return auxItem;
  };
  const seeAll = () => {
    navigate(`/ver-todo/?title=${props.tituloGeneral}` +
    `&contentType=Autores`,
     {
      state: {
        infoArray: props.referenciaPlantillaContenido
      },
    });
  };

  return (
    <section className="m-feraturedauthors">
      <div className="m-feraturedauthors__header">
        <h2>{props.tituloGeneral === "" ? `Autores` : props.tituloGeneral}</h2>
        {props.referenciaPlantillaContenido.length > 5 && (
          <p 
            onClick={() => seeAll()}
            className={`gtm${normalizeTwoWords(props.nombreCategoria)}${
              normalizeTwoWords(props.tituloGeneral)}${normalizeTwoWords(props.tituloBoton)}`
            }
          >
            {props.tituloBoton}
          </p>
        )}
      </div>
      <div className="hide-on-mobile">
        <Slider ref={(_slider) => setSlider(_slider)} {...settings}>
          {props.referenciaPlantillaContenido.map((author, index) => {
            return (
              <div key={index}>
                <CardAuthor author={author} key={index} gtmClass={`gtm${normalizeTwoWords(props.nombreCategoria)}ClicAutores${normalizeTwoWords(author.tituloBanner)}`}/>
              </div>
            );
          })}
        </Slider>
        {props.referenciaPlantillaContenido.length > 4 && (
          <>
            <div
              className="arrow-content arrow-content__left"
              onClick={isActiveBack(goToBack, undefined)}
            >
              <div className="arrows">
                <div className="arrows-contain">
                  <div
                    className={isActiveBack(
                      "arrow icon-chevron-left active",
                      "arrow icon-chevron-left"
                    )}
                  />
                </div>
              </div>
            </div>
            <div
              className="arrow-content arrow-content__right"
              onClick={isActiveNext(goToNext, undefined)}
            >
              <div className="arrows">
                <div className="arrows-contain">
                  <div
                    className={isActiveNext(
                      "arrow icon-chevron-right active",
                      "arrow icon-chevron-right"
                    )}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="show-on-mobile">
        <Slider {...settings}>
          {handleLimitData().map((author, index) => {
            return (
              <div key={index}>
                <CardAuthor author={author} key={index} />
              </div>
            );
          })}
        </Slider>
      </div>
      <div className="background-color"></div>
    </section>
  );
};

export default FeaturedAuthors;
